import { archiveSystem, deleteSystem, unarchiveSystem } from "services/systems-service";

export const callDeleteAction = async (itemToDelete, onClose, refetch, setRefetch, SwalReact, t) => {
  const result = await deleteSystem(itemToDelete?._id);
  if (result.status === 200 || result.status === 204) {
    onClose();
    setRefetch(!refetch);
    SwalReact.fire({
      title: t('mapping:systems.toasts.successTitle'),
      text: t('mapping:systems.toasts.deleted'),
      icon: 'success',
    });
  } else {
    throw new Error(t('mapping:systems.toasts.errorDelete'));
  }
};

export const callArchiveAction = async (itemToArchive, onClose, refetch, setRefetch, SwalReact, t) => {
  const result = await archiveSystem(itemToArchive?._id);
  if (result.status === 200) {
    onClose();
    setRefetch(!refetch);
    SwalReact.fire({
      title: t('mapping:systems.toasts.successTitle'),
      text: t('mapping:systems.toasts.archived'),
      icon: 'success',
    });
  } else {
    throw new Error(t('mapping:systems.toasts.errorArchive'));
  }
};

export const callUnarchiveAction = async (itemToUnarchive, onClose, refetch, setRefetch, SwalReact, t) => {
  const result = await unarchiveSystem(itemToUnarchive?._id);
  if (result.status === 200) {
    onClose();
    setRefetch(!refetch);
    SwalReact.fire({
      title: t('mapping:systems.toasts.successTitle'),
      text: t('mapping:systems.toasts.unarchived'),
      icon: 'success',
    });
  } else {
    throw new Error(t('mapping:systems.toasts.errorUnarchive'));
  }
};
